.tabs {
  display: block;
  border-top: 1px solid;
}

.tab {
  float: left;
  display: block;
  line-height: 2em;
  border-right: 1px solid;
  padding: 0 1em;
  user-select: none;
  cursor: pointer;
  position: relative;
}

.tab--active ,
.tab:hover {
  background: rgba(0, 0, 0, 0.1);
}

.tab--active:before {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  border-bottom: 3px solid;
}

.tab--modified:after {
  content: '*';
  display: inline-block;
  color: orange;
  margin-left: 1em;
  font-weight: bold;
}
